export default class TimeEntryProfileMapEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#time_entry_profile_map_uuid") ? (elem.querySelector("#time_entry_profile_map_uuid") as HTMLInputElement).value : null,
            from: (elem.querySelector("#time_entry_profile_map_from") as HTMLInputElement).value,
            to: (elem.querySelector("#time_entry_profile_map_to") as HTMLInputElement).value,
            time_entry_profile_id: elem.querySelector("#new_time_entry_profile_map_time_entry_profile_id") ? (elem.querySelector("#new_time_entry_profile_map_time_entry_profile_id option:checked") as HTMLInputElement).value : (elem.querySelector("#time_entry_profile_map_time_entry_profile_id option:checked") as HTMLInputElement).value,
        }
    }
}